import React, { useContext, useMemo } from 'react';
import RisingTopics from '@op/pages/Summary/components/RisingTopics';
import { FilterContext } from '../../context';
import { clickTopicToFeedsWithTab } from '@op/utils/url';
import { useHistory } from 'umi';

export default function MainChangeTopics({}: any) {
  const { topicLevel, filter, transTopic, gameInfo, topicTree } =
    useContext(FilterContext);
  const history = useHistory();
  const params = useMemo(() => {
    return { ...filter, topic_level: topicLevel };
  }, [filter, topicLevel]);

  const goToFeeds = (topic: string) => {
    let topics: any = [topic];
    if (topicLevel === 'L1') {
      topics = topicTree?.[topic] || [];
    }
    clickTopicToFeedsWithTab({
      filter: { ...filter, topic: topics },
      gameInfo,
      history,
    });
  };

  return (
    <RisingTopics
      translateTopic={(name: string) => {
        return transTopic(name, topicLevel);
      }}
      loadingHeight={360}
      emptyHeight={360}
      itemClick={goToFeeds}
      filter={params}
      gameInfo={gameInfo}
      contentCard
    />
  );
}
